module.exports = __webpack_public_path__ + "img/hierarchy-3.b4cfe60e.svg";